// src/stats/infrastructure/ui-services/matchStatsUiService.ts
import {
  $MATCH_GK_PLAYER_STATS,
  $MATCH_PLAYER_STATS,
  $MATCH_TEAM_STATS,
} from "~/src/stats/domain/services/matchStatsService";
import type { Parameter } from "~/src/stats/domain/models/Parameter";
import type { MatchStatsPlayerData, MatchStatsTeamData } from "~/src/stats/domain/models/MatchStats";
import type { PlayerRole } from "~/src/player/domain/Player";

interface MatchStatsUiService {
  filterMatchTeamStats: (parameters: Parameter[], stats: MatchStatsTeamData[]) => MatchStatsTeamData[];
  filterMatchPlayerStats: (
    parameters: Parameter[] | undefined,
    stats: MatchStatsPlayerData[] | null | undefined,
    playerRole: PlayerRole
  ) => MatchStatsPlayerData[];
}

export default (): MatchStatsUiService => {
  return {
    filterMatchTeamStats,
    filterMatchPlayerStats,
  };

  function filterMatchTeamStats(
    parameters: Parameter[],
    matchTeamStats: MatchStatsTeamData[]
  ): MatchStatsTeamData[] {
    return $MATCH_TEAM_STATS.reduce<MatchStatsTeamData[]>((acc, code) => {
      const parameter = parameters.find(p => p.code === code);
      const matchTeamStat = matchTeamStats.find(ms => ms.parameterCode === code);

      if (!parameter && !matchTeamStat) {
        return acc;
      }

      const newStat: MatchStatsTeamData = {
        parameterName: parameter?.name,
        parameterMeasureUnit: parameter?.measureUnit,
        ...(matchTeamStat || {
          total: "-",
          id: null,
          total1T: 0,
          total2T: 0,
          parameterCode: code,
        }),
      };

      return [...acc, newStat];
    }, []);
  }

  function filterMatchPlayerStats(
    parameters: Parameter[],
    matchPlayerStats: MatchStatsPlayerData[],
    playerRole: PlayerRole
  ): MatchStatsPlayerData[] {
    if (playerRole == "goalkeeper") {
      return $MATCH_GK_PLAYER_STATS.reduce<MatchStatsPlayerData[]>((acc, code) => {
        const parameter = parameters.find(p => p.code === code);
        const matchPlayerStat = matchPlayerStats.find(ms => ms.parameterCode === code);

        if (!parameter && !matchPlayerStat) {
          return acc;
        }

        const newStat: MatchStatsPlayerData = {
          parameterName: parameter?.name,
          parameterMeasureUnit: parameter?.measureUnit,
          ...(matchPlayerStat || {
            total: "-",
            id: null,
            minutes: null,
            total1T: 0,
            total2T: 0,
            parameterCode: null,
          }),
        };

        return [...acc, newStat];
      }, []);
    } else {
      return $MATCH_PLAYER_STATS.reduce<MatchStatsPlayerData[]>((acc, code) => {
        const parameter = parameters.find(p => p.code === code);
        const matchPlayerStat = matchPlayerStats.find(ms => ms.parameterCode === code);

        if (!parameter && !matchPlayerStat) {
          return acc;
        }

        const newStat: MatchStatsPlayerData = {
          parameterName: parameter?.name,
          parameterMeasureUnit: parameter?.measureUnit,
          ...(matchPlayerStat || {
            total: "-",
            id: null,
            minutes: null,
            total1T: 0,
            total2T: 0,
            parameterCode: null,
          }),
        };

        return [...acc, newStat];
      }, []);
    }
  }
};
